export const maxAlertItemsCount = 2;
